







import Component, { mixins } from 'vue-class-component';
import LeftSidebar from '@/components/leftSidebar/leftSidebar.vue';
import SideBarPreloader from '@/components/leftSidebar/SideBarPreloader.vue';

@Component({
  components: {
    SideBarPreloader,
  },
})
export default class LeftSidebarComponentError extends mixins(LeftSidebar) {
}
